import { render, staticRenderFns } from "./QuizSlide.vue?vue&type=template&id=6e20514c&"
import script from "./QuizSlide.vue?vue&type=script&lang=js&"
export * from "./QuizSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "QuizSlide.vue"
export default component.exports